module.exports = __webpack_public_path__ + "assets/img/user_subscribes_l2.7aefcf17.png";